interface StoresTranslations {
  pageTitle: string;
  subtitle: string;
}

export const storesTemplateTranslations: Record<string, StoresTranslations> = {
  en: {
    pageTitle: "LOCATIONS AND SERVICE",
    subtitle: "Find our nearest authorized dealers for sales and service"
  },
  de: {
    pageTitle: "STANDORTE UND SERVICE",
    subtitle: "Finden Sie unsere nächstgelegenen Vertragshändler für Verkauf und Service"
  },
  fr: {
    pageTitle: "EMPLACEMENTS ET SERVICE",
    subtitle: "Trouvez nos revendeurs agréés les plus proches pour la vente et le service"
  },
  zh: {
    pageTitle: "销售网点与服务",
    subtitle: "寻找最近的授权经销商进行销售和服务"
  }
}; 